import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import yup from '../../utility/yup';

import {
  ItemForm, ViewFrame, FormInput,
} from '../../components';
import { useTitle } from '../../hooks';
import { Loadable } from '../../store/types';
import { Customer } from '../../types/items';
import SavedSearchService, { SavedSearchPages } from '../../services/SavedSearchService';

const customerSchema = yup.object().shape({
  first_name: yup.string()
    .matches(/^[\p{Alpha}\s+(.\-`'&)]+$/u, 'first_name has a wrong symbols')
    .required()
    .trim(),
  last_name: yup.string()
    .matches(/^[\p{Alpha}\s+(.\-`'&)]+$/u, 'last_name has a wrong symbols')
    .required()
    .trim(),
  email: yup.string().email(),
});

type Props = {
  creatingMode?: boolean;
  record: Loadable<Customer>;
  onSubmit: (record: Customer) => void;
};

const CustomerForm = ({
  creatingMode = false,
  record: { loading, data },
  onSubmit,
}: Props) => {
  const dispatch = useDispatch();
  const title = data?.ref.full_name_first_last || 'New Customer';

  useTitle(title);

  useEffect(() => {
    const hotKeyList = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key?.toLocaleLowerCase() === 'l') {
        event.preventDefault();
        dispatch(push('/dashboard/admin/customers'));
      }
    };
    window.addEventListener('keydown', hotKeyList);

    return () => {
      window.removeEventListener('keydown', hotKeyList);
    };
  }, [dispatch]);

  return (
    <ViewFrame
      loading={loading}
      title={title}
      backToListLink
    >
      <ItemForm
        creatingMode={creatingMode}
        initialValues={data}
        validationSchema={customerSchema}
        onSubmit={onSubmit}
        loading={loading}
        editPermitted={Boolean(data?.permissions.can_edit)}
        enableReinitialize
        preventCancelChanges
        validateOnMount={false}
        validateOnBlur={false}
        validateOnChange
      >
        <Grid container spacing={4}>
          <Grid item sm={6} xs={12}>
            <FormInput
              label="First name"
              name="first_name"
              autoFocus
              getValueAfterInit={() => SavedSearchService.getValue(SavedSearchPages.Customers)}
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <FormInput
              label="Last Name"
              name="last_name"
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <FormInput
              label="Organization"
              name="ref.organization.common_name"
              disabled
              spellCheck
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <FormInput
              label="Project"
              name="ref.project.title"
              disabled
              spellCheck
            />
          </Grid>
          {/*<Grid item xs={12}>*/}
          {/*  <FormInput*/}
          {/*    label="Email"*/}
          {/*    name="email"*/}
          {/*  />*/}
          {/*</Grid>*/}
          {/*<Grid item xs={12}>*/}
          {/*  <FormInput*/}
          {/*    label="Address 1"*/}
          {/*    name="address1"*/}
          {/*  />*/}
          {/*</Grid>*/}
          {/*<Grid item xs={12}>*/}
          {/*  <FormInput*/}
          {/*    label="Address 2"*/}
          {/*    name="address2"*/}
          {/*  />*/}
          {/*</Grid>*/}
          {/*<Grid item xs={4}>*/}
          {/*  <FormInput*/}
          {/*    label="City"*/}
          {/*    name="city"*/}
          {/*  />*/}
          {/*</Grid>*/}
          {/*<Grid item xs={4}>*/}
          {/*  <FormInput*/}
          {/*    label="State"*/}
          {/*    name="state"*/}
          {/*  />*/}
          {/*</Grid>*/}
          {/*<Grid item xs={4}>*/}
          {/*  <FormInput*/}
          {/*    label="Zip"*/}
          {/*    name="zip"*/}
          {/*  />*/}
          {/*</Grid>*/}
          {/*<Grid item xs={12}>*/}
          {/*  <FormInput*/}
          {/*    label="Notes"*/}
          {/*    name="note"*/}
          {/*    type="textarea"*/}
          {/*  />*/}
          {/*</Grid>*/}
          {/*<Grid item xs={4}>*/}
          {/*  <FormInput*/}
          {/*    label="Created"*/}
          {/*    name="ref.created_age"*/}
          {/*    disabled*/}
          {/*  />*/}
          {/*</Grid>*/}
          {/*<Grid item xs={4}>*/}
          {/*  <FormInput*/}
          {/*    label="Last update"*/}
          {/*    name="ref.updated_age"*/}
          {/*    disabled*/}
          {/*  />*/}
          {/*</Grid>*/}
          {/*<Grid item xs={4}>*/}
          {/*  <FormInput*/}
          {/*    label="Register Count"*/}
          {/*    name="register_count"*/}
          {/*    disabled*/}
          {/*  />*/}
          {/*</Grid>*/}
        </Grid>
      </ItemForm>
    </ViewFrame>
  );
};

export default CustomerForm;
